import { Datatype } from '@framework/engine';
import { yup } from '@framework/validation';

/**
 * Restituisce lo schema di validazione per una colonna in base al tipo di dato.
 */
export function getDatatypeColumnSchema(datatype: Datatype | null | undefined) {
  if (!datatype) return yup.mixed().notRequired();

  if (datatype === Datatype.String) {
    return yup.string().notRequired();
  }
  if (datatype === Datatype.Number) {
    return yup.number().notRequired();
  }
  if (datatype === Datatype.Boolean) {
    return yup.boolean().notRequired();
  }
  if (datatype === Datatype.Date) {
    return yup.string().stringDate().notRequired();
  }
  // Non sono gestiti gli altri tipi di dato, non strippiamo per evitare problemi in futuro
  return yup.mixed().notRequired();
}
